module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/about-confirm-d50617b7bbe672495ebb06bf6879038b.png";